var loadURL = function(url) {
  var iFrame;
  iFrame = document.createElement("iframe");
  iFrame.setAttribute("src", url);
  iFrame.setAttribute("style", "display:none;");
  iFrame.setAttribute("height", "0px");
  iFrame.setAttribute("width", "0px");
  iFrame.setAttribute("frameborder", "0");
  document.body.appendChild(iFrame);
  // 发起请求后这个iFrame就没用了，所以把它从dom上移除掉
  iFrame.parentNode.removeChild(iFrame);
  iFrame = null;
}

module.exports = {
    /*=========================================================
       * 路由跳转方法
       * @param openSource  源
       * @param openType  类型
       * @param functioncode  功能号
       * @param parameters  参数
    ========================================================*/
    openService(openSource, openType, functioncode, parameters) {
      var ua = window.navigator.userAgent.toLowerCase();
      //判断当前设备是否为苹果
      if (ua.match(/iphone|ipod|ipad/)) {
        // 1.JSON数据转成字符串
        var JSONString = JSON.stringify(parameters);
        // 2.将JSON字符串中的":"转换成"%3A"
        JSONString = JSONString.split(":").join("%3A");
        // 3.拼接请求
        var requestString = "KDS_Native://openService:" + openSource + ":" + openType + ":" + functioncode + ":" + JSONString;
        // 4.发送请求
        loadURL(requestString);
        //判断当前设备是否为安卓
      } else if (ua.match(/android/i)) {
        //console.log('andorid');
        window.KDS_Native.openService(openSource, openType, functioncode, JSON.stringify(parameters));
      } else {
        //console.log('other');
      }
    },

    /*============================================
       * 日期格式处理方法
       * @param date  日期，Date格式
       * @param type  格式类型，0：2025-05-10, 1: 2025年5月10日
    =============================================*/
    getFormatData(date, type)
    {
        let y = date.getFullYear(), m = date.getMonth()+1, d = date.getDate();
        if (type == 0) {
          m = m > 9 ? m : '0' + m;
          d = d > 9 ? d : '0' + d;
          return y + '-' + m + '-' + d;
        } else if (type == 1) {
          return y + '年' + m + '月' + d + '日';
        }       
    }
};
